module.exports = __webpack_public_path__ + "static/depoimento16-69ed51e519daf05d986eff052107240c.png";